import { HStack } from "@chakra-ui/react";
import { ButtonDefault } from "../ButtonDefault";

interface FooterProps {
  waiting?: boolean;
  disabled?: boolean;
  onOpen: () => void;
}

export function Footer({
  waiting = false,
  disabled = false,
  onOpen,
} : FooterProps) {
  return (
    <HStack
      w="100%"
      ml="auto"
      alignItems="center"
      justifyContent="space-between"
      borderBottomRadius="5"
    >
      <ButtonDefault
        onClick={onOpen}
        warning={waiting}
        disabled={disabled}
        w={["100%"]}
        h={["25px"]}
        mt={1}
        fontSize={["small"]}
        text={waiting ? 'Lista de Espera' : 'Saiba mais...'}
      />
    </HStack>
  )
}
